/**
 * The dot that sits on the changed element itself — the third level of D1.
 *
 * Small, quiet, and never the only information: it carries a `title` and an accessible label,
 * because a coloured dot says nothing to a screen reader and not much to anybody who has not
 * been told what it means.
 *
 * Not amber: amber reads as "a person has to act", and a new feature is not an overdue invoice.
 * (In `pure-app`, where this came from, `blue-500` is remapped to the Dolder green; in
 * `reporting_app` it is the stock blue of every other primary action.)
 */

interface Props {
    /** Overrides the default label where "New" is not the right word for the element. */
    label?: string;
}

export function NewMarker({ label = 'New' }: Props) {
    return (
        <span
            className="ml-1 inline-flex h-1.5 w-1.5 shrink-0 rounded-full bg-blue-500 align-middle"
            title={label}
            role="img"
            aria-label={label}
        />
    );
}
